
seedWebServices.service('UserSettingService', ['$resource', '$routeParams', '$http', '$cacheFactory', function ($resource, $routeParams, $http, $cacheFactory) {

	var serviceCache = $cacheFactory('UserSettingService');

	var _srvData = {
		loadedItem: null,
		isLoaded: false,
		listItems: [],
		tab: null
	};

	var baseUrl = '../Api/UserSettingApi';
		
	var res = $resource(baseUrl + '/:id', {}, {
		list: { method: 'GET', params: { stringFilter: 'stringFilter', tabFilter: 'tabFilter', sortField : 'sortField', skipNumber: 'skipNumber', takeNumber: 'takeNumber', groupFilter: 'groupFilter' }, isArray: true, cache: serviceCache }, //cache: serviceCache
        get: { method: 'GET', params: { id: 'id', invitation: 'invitation' }, isArray: false, cache: serviceCache },
		save: { method: 'POST', params: { id: 'id' }, isArray: false},
		put: { method: 'PUT', params: { data: 'data' }, isArray: false},
		'delete': {method: 'DELETE', params: {id: 'id'}, isArray: false},
		deleteBatch: {method: 'DELETE', params: {ids: 'ids'}, isArray: false},
		execute : {method: 'GET', params: { id: 'id' }, isArray: true},
		action: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: false },
		enabledOnly: { method: 'GET', params: { enabledOnly: 'true' }, isArray: true, cache: serviceCache },
		getList: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: true }
	});

	// apiMethod = '/doSomething'
	res.getMethod = function (apiMethod, parameters, isCacheable, responseType, headers) {
		var cache = false;
		if (isCacheable) {
			cache = serviceCache;
		}

		var config = {
			params: parameters,
			cache: cache
		};

		if (responseType) {
			config.responseType = responseType;
		}

		if (headers) {
			config.headers = headers;
		}
		return $http.get(baseUrl + apiMethod, config);
	};

	res.postMethod = function (apiMethod, data, config) {
		return $http.post(baseUrl + apiMethod, data, config);
	};

	res.putMethod = function (apiMethod, data, config) {
		return $http.put(baseUrl + apiMethod, data, config);
	};

	res.getData = function () {
		return _srvData;
	};

	res.resetCache = function ()
	{
		_srvData.loadedItem = null;
		_srvData.tab = null;
		_srvData.listItems = null;
		serviceCache.removeAll();
	};

	var searchFilter = '';
	res.getSearchFilter = function ()
    {
		return searchFilter;
	};

	res.setSearchFilter = function (newSearchFilter)
	{
		searchFilter = newSearchFilter;
	};

	res.getGroupFilter = function () {
		if ($routeParams.group) {
			return $routeParams.group;
		}
		else {
			return '';
		}	    
	};

	var tabPages = [];
	res.getActualPage = function (tabID)
	{
		return tabPages[tabID];
	};

	res.setActualPage = function (tabID, newActualPage)
	{
		tabPages[tabID] = newActualPage;
	};

	var columnSearchFilter = [];
	res.getColumnSearchFilter = function (tabID)
	{
		if (!columnSearchFilter[tabID]) {
			columnSearchFilter[tabID] = [];
		}
		return columnSearchFilter[tabID];
	};

	res.setColumnSearchFilter = function (tabID, newSearchFilter)
	{
		columnSearchFilter[tabID] = newSearchFilter;
	};

	var tableSort = [];
	res.getTableSort = function (tabID)
	{
		return tableSort[tabID];
	};

	res.setTableSort = function (tabID, newSort)
	{
		tableSort[tabID] = newSort;
	};
	
    res.getTabTotals = function (filterTabs) {
		var tabs = [];
		for (var i in filterTabs) {
			var tab = filterTabs[i];
			tabs.push({tabID: tab.ID, tabName: tab.Name, tabOrder: tab.TabOrder, tabFilter: tab.Filter, tabCount: 0});
		}
	    var params = {        
			tabs: tabs
        };
        return true;
	    //return res.getMethod ('/GetTabTotals', params, true);
	};

    res.getInvitations = function () {
        return $http.get('../Api/UserSettingApi/GetInvitations', {
            params: {},
            cache: false
        });
    };	

    res.checkInvitation = function (id, email, companyID) {
        return $http.get('../Api/UserSettingApi/CheckInvitation', {
            params: { invitationId: id, email: email, companyID: companyID },
            cache: false
        });
    };

	 res.getColumnValues = function (colName, tabFilter) {
        var params = {
            colName: colName,
			tabFilter: tabFilter,
        };
        return res.getMethod('/GetColumnValues', params, true);
    };

    res.getUserRoles = function () {
        return $http.get('../Api/UserSettingApi/GetUserRoles', {
            params: {},
            cache: serviceCache
        });
    };

    res.getUsersCount = function () {
        return $http.get('../Api/UserSettingApi/GetUsersCount', {
            params: {},
            cache: serviceCache
        });
	};

    res.getUsers = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put('../Api/UserSettingApi/SearchUsers', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    }

    res.inviteUser = function (email) {
        return $http.put('../Api/UserSettingApi/InviteUser', { email: email }, { cache: serviceCache });
    }

    res.changePasswordLink = function (email) {
        return $http.get('../Api/UserSettingApi/ChangePasswordLink', {
            params: { email: email }, 
            cache: serviceCache
        });
    }

    res.getUsersColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get('../Api/UserSettingApi/GetUsersColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
	}

	res.getUser = function () {
		return $http.get('../Api/UserSettingApi/GetUser', {
			params: {},
			cache: serviceCache
		});
	}

	res.getUserContacts = function (userID) {
		return $http.get('../Api/UserSettingApi/GetUserContacts', {
			params: { userID: userID }
		});
	};

	res.saveUserLanguage = function (userSettings) {
		return res.putMethod('/SaveUserLanguage', userSettings, { cache: false });
	};

	res.getUsersQuery = function (query) {
		var cache = serviceCache;
		return $http.get(baseUrl + '/GetUsersQuery', {
			params: { query: query },
			cache: cache
		});
	};

	res.getApprovalUsers = function () {
		return $http.get(baseUrl + '/GetApprovalUsers', {
			params: {},
			cache: serviceCache
		});
	}

	return res;	
},

]);
